import { memo } from 'react';
import classNames from 'classnames';
import css from './FormWrapper.module.scss';
import { useFormState } from '../../../context/Form/form';
import { FormWrapperProps } from './FormWrapper.types';

/**
 * This control provides styling to various child nodes as well as ensuring a specific
 * max width styling of none, 75%, or 100% width.
 *
 * @note Must be rendered inside of a {@link useFormState `FormProvider`} context.
 *
 * @param seventyFivePercentWidth - {@link FormWrapperProps.seventyFivePercentWidth seventyFivePercentWidth} description.
 * @param fullWidth - {@link FormWrapperProps.fullWidth fullWidth} description.
 * @param finePrint - {@link FormWrapperProps.finePrint finePrint} description.
 * @param requiredFieldLabel - {@link FormWrapperProps.requiredFieldLabel requiredFieldLabel} description.
 * @param children - {@link FormWrapperProps.children children} description.
 */
const FormWrapper = memo(({
    seventyFivePercentWidth = false,
    fullWidth = false,
    finePrint = false,
    requiredFieldLabel = false,
    children,
}: FormWrapperProps) => {
    const { fullWidthKioskInputs } = useFormState();

    return (
        <div
            role={'presentation'}
            className={classNames(
                css.formField,
                { [css.seventyFivePercentWidth]: seventyFivePercentWidth },
                { [css.fullWidth]: fullWidth || fullWidthKioskInputs },
                { [css.finePrint]: finePrint },
                { [css.requiredFieldLabel]: requiredFieldLabel },
            )}
        >
            {children}
        </div>
    );
});

export default FormWrapper;